import {
    Directive,
    ElementRef,
    Input,
    Optional,
    Renderer2,
    SimpleChanges
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

const DEFAULT_MIN_LENGTH = 3;
const DEFAULT_MAX_LENGTH = 255;

@Directive({
    selector: 'input[type=text],textarea'
})
export class FormLengthValidationDirective {
    @Input() allowAnyLength?: boolean;
    @Input() allowShortLength?: boolean;

    hasSetValidation = false;

    constructor(
        @Optional() private ngControl: NgControl,
        private renderer: Renderer2,
        private el: ElementRef
    ) {}

    ngOnInit() {
        this.applyDefaults();
    }

    ngOnChanges(changes: SimpleChanges) {
        // For controls that weren't ready on init of the directive, this will run on changes to hopefully add the validator to them too
        this.applyDefaults();
    }

    private applyDefaults() {
        if (this.allowAnyLength || this.ngControl == null || this.hasSetValidation) {
            return;
        }

        const nativeElement = this.el.nativeElement;
        const isTextarea = nativeElement.tagName === 'TEXTAREA';
        const validators = [];

        if (
            !this.allowShortLength &&
            !nativeElement.hasAttribute('minlength')
        ) {
            validators.push(Validators.minLength(DEFAULT_MIN_LENGTH));
            this.renderer.setAttribute(
                nativeElement,
                'minLength',
                DEFAULT_MIN_LENGTH.toString()
            );
        }

        if (!isTextarea && !nativeElement.hasAttribute('maxlength')) {
            validators.push(Validators.maxLength(DEFAULT_MAX_LENGTH));
            this.renderer.setAttribute(
                nativeElement,
                'maxLength',
                DEFAULT_MAX_LENGTH.toString()
            );
        }

        if (validators.length === 0) {
            this.hasSetValidation = true;
            return;
        }

        this.ngControl.control?.setValidators(
            Validators.compose([this.ngControl.control?.validator, ...validators])
        );
        this.ngControl.control?.updateValueAndValidity();
        this.hasSetValidation = true;
    }
}
